import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { ForwardedCostsReminderProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { ActionLinkButton, Icon, MessageBubble } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

// Points at ⋯ because that menu keeps the same entry once the reminder is closed. Info, not Warning:
// unbilled costs are something to act on, not a problem with the invoice. Rendered in body because the
// footer restyles every button inside it as a round footer button.
const ForwardedCostsReminder: React.FC<ForwardedCostsReminderProps> = ({
  show,
  customerName,
  summary,
  onOpen,
  onClose,
  children,
}) => {
  return (
    <MessageBubble
      placement="top"
      type={StyleEnums.DisplayType.Info}
      onClose={onClose}
      portalToBody
      message={
        show ? (
          <Grid container direction="column" rowGap={1}>
            <Grid item>
              {LocalizationHelperInstance.getFormattedMessage(
                TranslationKeys.Invoice.ForwardedCostsReminder,
                undefined,
                {
                  customerName,
                  count: summary.count,
                  amount: LocalizationHelperInstance.getFormattedNumber(summary.totalNetAmountSek, 2, 2),
                }
              )}
            </Grid>
            <Grid item>
              <ActionLinkButton
                className={cssExports.animatedLink}
                onClick={onOpen}
                testId="forwardedCostsReminderAction"
              >
                {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.ForwardedCostsReminderAction)}
                <Icon icon={IconDefinitionConstants.WArrowSmallRight} />
              </ActionLinkButton>
            </Grid>
          </Grid>
        ) : undefined
      }
    >
      {children}
    </MessageBubble>
  );
};

export default ForwardedCostsReminder;
